import 'mand-mobile/components/_style/global.styl'
import 'normalize.css'

import Vue from 'vue'
import App from '@/App.vue'
import router from '@/histroy'
import initVconsoleAsync from '@/lib/v-console'
import '@/assets/styles/base.styl'
import axios from '@/lib/axios'
import i18n from '@/i18n'
import store from '@/store'
import { isMobile, getQueryString, getToken } from '@/lib/common-util'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import '@babel/polyfill'
import Es6Promise from 'es6-promise'
// tslint:disable-next-line
require('es6-promise').polyfill()
Es6Promise.polyfill()
// tslint:disable-next-line
const version = require('../package.json').version

Vue.config.productionTip = false
Vue.use(axios)
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://ef2f1e749feb4450805c71bbdf1e8567@sentry.kreditpintar.com/54',
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
    release: version,
  })
}
Vue.directive('title', {
  inserted: (el, binding) => {
    if (typeof(el.dataset.title) === 'string') {
      document.title = el.dataset.title
    }
  },
  update: (el, binding) => {
    if (typeof(el.dataset.title) === 'string') {
      document.title = el.dataset.title
    }
  },
})
Vue.prototype.$addStorageEvent = (type: any, key: any, data: any) => {
  if (type === 1) {
    // 创建一个StorageEvent事件
    const newStorageEvent: any = document.createEvent('StorageEvent')
    const storage: any = {
      setItem: (k: any, val: any) => {
        localStorage.setItem(k, val)
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      },
    }
    return storage.setItem(key, data)
  } else {
    // 创建一个StorageEvent事件
    const newStorageEvent: any = document.createEvent('StorageEvent')
    const storage: any = {
      setItem: (k: any, val: any) => {
        sessionStorage.setItem(k, val)
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null)
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      },
    }
    return storage.setItem(key, data)
  }
}
router.beforeEach((to, from, next) => {
  sessionStorage.setItem('bizToken', to.query.biz_token as string)
  sessionStorage.setItem('failedReturnUrl', to.query.failedReturnUrl as string)
  if (to.path === '/index') {
    if (isMobile()) {
      if (to.query.language) {
        next({ name: 'imageHomeV2', query: { biz_token: to.query.biz_token, language: to.query.language}, replace: true })
      } else {
        next({ name: 'imageHomeV2', query: { biz_token: to.query.biz_token }, replace: true })
      }
    } else {
      if (to.query.language) {
        next({ name: 'webHomeV2', query: { biz_token: to.query.biz_token, language: to.query.language }, replace: true })
      } else {
        next({ name: 'webHomeV2', query: { biz_token: to.query.biz_token }, replace: true })
      }
    }
  }
  if (to.path === '/h5/index' && !isMobile()) {
    if (to.query.language) {
      next({ name: 'webHomeV2', query: { biz_token: to.query.biz_token, language: to.query.language }, replace: true })
    } else {
      next({ name: 'webHomeV2', query: { biz_token: to.query.biz_token }, replace: true })
    }
  }
  if (to.path === '/web/index' && isMobile()) {
    if (to.query.language) {
      next({ name: 'imageHomeV2', query: { biz_token: to.query.biz_token, language: to.query.language }, replace: true })
    } else {
      next({ name: 'imageHomeV2', query: { biz_token: to.query.biz_token }, replace: true })
    }
  }
  next();
})
window.vue = new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App),
})

if (process.env.VUE_APP_CONSOLE === 'Yes') {
  initVconsoleAsync()
}
